<template>
  <div class="mobile-wrapper">
    <img src="../../../assets/img/mobile/mobile-logo.png" alt="" class="mobile-logo">


    <swiper
      ref="swiper"
      style="width: 100%;"
      navigation
      :pagination="{ clickable: true }"
      :options="swiperOption"
      >
      <swiper-slide >
        <indexPage @toNext="toNext"/>
      </swiper-slide>
      <swiper-slide >
        <totalPage @toNext="toNext"/>
      </swiper-slide>
      <swiper-slide >
        <detailPage/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import indexPage from '@/views/mobile/components/index'
import totalPage from '@/views/mobile/components/total'
import detailPage from '@/views/mobile/components/detail'
export default {
  name: "mobile",
  data() {
    return {
      swiperOption:{
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
      }
    }
  },
  created() {
  },
  components: {
    Swiper, SwiperSlide,
    indexPage,
    totalPage,
    detailPage,
  },
  methods: {
    toNext(num){
      console.log(this.$refs.swiper)
      this.$refs.swiper.$swiper.slideTo(num, 1000, true);
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.mobile-wrapper{
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: url(../../../assets/img/mobile/mobile-bg.png) no-repeat top center;
  background-size: 100% 100%;
  padding: 20px;
  .mobile-logo{
    display: block;
    width: 90%;
  }
}
.swiper-pagination{
  position: fixed;
  bottom: 0;
}
</style>






